// Module
var code = "<script>let $ctrl</script> <organism-wizard-confirm-view ng-if=\"$ctrl.startRequests\" expected-error-list=\"$ctrl.expectedErrorList\" service-wizard-confirm=\"$ctrl.domainWizardConfirmation\" wizard-create-object-list=\"$ctrl.wizardCreateObjectList\"></organism-wizard-confirm-view> ";
// Exports
module.exports = code;